/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ permission: NonNullable<unknown> }} Adm_Section_Denied_BodyInputs */

const en_adm_section_denied_body = /** @type {(inputs: Adm_Section_Denied_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`You need the permission "${i?.permission}" for this section. Ask an owner or admin to grant it.`)
};

const de_adm_section_denied_body = /** @type {(inputs: Adm_Section_Denied_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Für diesen Bereich brauchst du die Berechtigung "${i?.permission}". Bitte einen Eigentümer oder Admin, sie dir zu geben.`)
};

/**
* | output |
* | --- |
* | "You need the permission \"{permission}\" for this section. Ask an owner or admin to grant it." |
*
* @param {Adm_Section_Denied_BodyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const adm_section_denied_body = /** @type {((inputs: Adm_Section_Denied_BodyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Adm_Section_Denied_BodyInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_adm_section_denied_body(inputs)
	return en_adm_section_denied_body(inputs)
});